import moment from "moment";

export const getDates = (start, end) => {
  let datesArr = [];
  // let allStarts = [];
  // let allEnds = [];
  // frequencies.forEach(freq => {
    let startDate = moment(start, "YYYY-MM-DD");
    let endDate = moment(end, "YYYY-MM-DD");
    // let durationVal = freq.taskDuration.split("_");
    // if (freq.isWeeklyFreq) {
    //   let freqDays = []; 
    //   if (durationVal[1].toString().toLowerCase().includes("day")) {
    //     freq.weekDays.forEach(d => {
    //       let nextDays = parseInt(d) + (parseInt(durationVal[0]) - 1);
    //       let s = parseInt(d);
    //       while (s <= nextDays) {
    //         freqDays.push(s);
    //         s++;
    //       }
    //       console.log(nextDays, d)
    //     });
    //   } else {
    //     freqDays = [1, 2, 3, 4, 5, 6, 7];
    //   }
    //   // allStarts.push(moment(freq.start_date, "YYYY-MM-DD"));
    //   // allEnds.push(moment(freq.end_date, "YYYY-MM-DD"));

    //   for (let m = moment(startDate); m.diff(endDate, 'days') <= 0; m.add(1, 'day')) {
    //     let day = moment(m).day();
    //     if (day === 0) {
    //       day = 7;
    //     }
    //     if (!datesArr.find(x => x.id === m.unix()) && freqDays.includes(day)) {
    //       datesArr.push({
    //         id: m.unix(),
    //         name: m.format("DD/MM"),
    //         day: m.format("ddd"),
    //         start_date: m.format("YYYY-MM-DD")
    //       });
    //     }
    //   }
    // } else {
      // allStarts.push(moment(freq.start_date, "YYYY-MM-DD"));
      // allEnds.push(moment(freq.end_date, "YYYY-MM-DD"));
      for (let m = moment(startDate); m.diff(endDate, 'days') <= 0; m.add(1, 'day')) {
        if (!datesArr.find(x => x.id === m.unix())) {
          datesArr.push({
            id: m.unix(),
            name: m.format("DD/MM"),
            day: m.format("ddd"),
            start_date: m.format("YYYY-MM-DD")
          });
        }
      }
    // }
  // });
  // let allStarts = frequencies.map(x => moment(x.start_date, "YYYY-MM-DD"));
  // let allEnds = frequencies.map(x => moment(x.end_date, "YYYY-MM-DD"));

  // let startDate = moment.min([...allStarts]);
  // let endDate = moment.max([...allEnds]);

  // for (let m = moment(startDate); m.diff(endDate, 'days') <= 0; m.add(1, 'day')) {
  //   if (!datesArr.find(x => x.id === m.unix())) {
  //     datesArr.push({
  //       id: m.unix(),
  //       name: m.format("DD/MM"),
  //       day: m.format("ddd"),
  //       start_date: m.format("YYYY-MM-DD")
  //     });
  //   }
  // }
  return datesArr.sort((a, b) => a.id - b.id);
}

export const getDayHours = () => {
  let date = moment().startOf("day");
  let hours = [];
  for (let m = moment(date).subtract(1, "day"); date.diff(m, 'hours') > 0; m.hour === 23 ? m.add(59, "minutes") : m.add(1, 'hour')) {
    hours.push({
      id: m.unix(),
      name: m.format("HH:mm"),
      end_name: m.hour() === 23 ? moment(m).add(59, "minutes").format("HH:mm") : moment(m).add(1, "hour").format("HH:mm")
    });
  }
  return hours;
}